import { render, staticRenderFns } from "./EditCfContactModal.vue?vue&type=template&id=3ec6e130&"
import script from "./EditCfContactModal.vue?vue&type=script&lang=js&"
export * from "./EditCfContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports